import { type RepoPaginationResponse } from '@webapp/infrastructure/interfaces/repositories/RepoPaginationResponse'
import { CatalogPermissionConfigList } from '@webapp/modules/purchasing/components/CatalogPermissionConfigList'
import { type CatalogPermissionUserConfig } from '@webapp/modules/purchasing/entities/CatalogPermissionUserConfig'
import messages from './messages'

export interface ICatalogPermissionUserConfigTableProps {
  items: CatalogPermissionUserConfig[]
  selectedUserId: Nullable<number>
  onSelectUser: (user: CatalogPermissionUserConfig) => void
  isLoading: boolean
  isError: boolean
  searchValue: string
  onSearchChange: (value: string) => void
  onSearchSubmit: (value: string) => void
  paging: RepoPaginationResponse
  onPageChange: (page: number) => void
}

export const CatalogPermissionUserConfigTable = ({
  items,
  selectedUserId,
  onSelectUser,
  ...listProps
}: ICatalogPermissionUserConfigTableProps) => (
  <CatalogPermissionConfigList
    items={items}
    getItemLabel={(user) => user.displayName}
    selectedId={selectedUserId}
    onSelect={onSelectUser}
    messages={messages}
    {...listProps}
  />
)

CatalogPermissionUserConfigTable.displayName =
  'CatalogPermissionUserConfigTable'
